<script lang="ts" setup>
import ToggleSwitch from "primevue/toggleswitch";
</script>

<template>
  <ToggleSwitch class="shrink-0" v-bind="$attrs" />
</template>
